import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import {
  BASE_URL,
  FAQ_LIST,
  FAQ_UPDATE,
  FAQ_RESPONSE_CODE,
  FAQ_RESPONSE_CODE_UPDATE,
  M_GET,
  M_POST,
  PG_URL,
  PGC_URL,
  AMB_SUPER_GAMES_URL,
  AMB_POKER_URL
} from '@/utils/api';
import type { IFaqUpdate, IFaqResponseCodeUpdate } from '@/interface/Faq';
import serviceUtils from '@/services/utils';

@Module({ name: 'faq' })
export default class Faq extends VuexModule {
  // Askmeslot
  @Action({ rawError: true })
  async FetchFaqList() {
    try {
      const { data } = await axios({
        url: BASE_URL + FAQ_LIST,
        method: M_GET
      });

      assertOk(data, 'Fetch faq list failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch faq list failed');
    }
  }

  @Action({ rawError: true })
  async UpdateFaq(params: IFaqUpdate[]) {
    try {
      const { data } = await axios({
        url: BASE_URL + FAQ_UPDATE,
        method: M_POST,
        data: {
          list: params
        }
      });

      assertOk(data, 'Update faq failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Update faq failed');
    }
  }

  @Action({ rawError: true })
  async FetchResponseCodeList() {
    try {
      const { data } = await axios({
        url: BASE_URL + FAQ_RESPONSE_CODE,
        method: M_GET
      });

      assertOk(data, 'Fetch response code list failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch response code list failed');
    }
  }

  @Action({ rawError: true })
  async UpdateResponseCode(params: IFaqResponseCodeUpdate) {
    try {
      const { data } = await axios({
        url: BASE_URL + FAQ_RESPONSE_CODE_UPDATE,
        method: M_POST,
        data: params
      });

      assertOk(data, 'Update response code failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Update response code failed');
    }
  }

  @Action({ rawError: true })
  async FetchPGFaqList() {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: `${PG_URL}${FAQ_LIST}?role=${user.role}`,
        method: M_GET
      });

      assertOk(data, 'Fetch pg faq list failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch pg faq list failed');
    }
  }

  // PG
  @Action({ rawError: true })
  async UpdatePGFaq(params: IFaqUpdate[]) {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: PG_URL + FAQ_UPDATE,
        method: M_POST,
        data: {
          list: params,
          id: user._id,
          username: user.username,
          source: user.source,
          parentId: user.parent
        }
      });

      assertOk(data, 'Update faq failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Update faq failed');
    }
  }

  @Action({ rawError: true })
  async FetchPGResponseCodeList() {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: `${PG_URL}${FAQ_RESPONSE_CODE}?role=${user.role}`,
        method: M_GET
      });

      assertOk(data, 'Fetch pg response code list failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch pg response code list failed');
    }
  }

  @Action({ rawError: true })
  async UpdatePGResponseCode(params: IFaqResponseCodeUpdate) {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: PG_URL + FAQ_RESPONSE_CODE_UPDATE,
        method: M_POST,
        data: {
          list: params,
          id: user._id,
          username: user.username,
          source: user.source,
          parentId: user.parent
        }
      });

      assertOk(data, 'Update response code failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Update response code failed');
    }
  }

  // PGC
  @Action({ rawError: true })
  async FetchPGCFaqList() {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: `${PGC_URL}${FAQ_LIST}?role=${user.role}`,
        method: M_GET
      });

      assertOk(data, 'Fetch pg faq list failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch pg faq list failed');
    }
  }

  @Action({ rawError: true })
  async UpdatePGCFaq(params: IFaqUpdate[]) {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: PGC_URL + FAQ_UPDATE,
        method: M_POST,
        data: {
          list: params,
          id: user._id,
          username: user.username,
          source: user.source,
          parentId: user.parent
        }
      });

      assertOk(data, 'Update faq failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Update faq failed');
    }
  }

  @Action({ rawError: true })
  async FetchPGCResponseCodeList() {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: `${PGC_URL}${FAQ_RESPONSE_CODE}?role=${user.role}`,
        method: M_GET
      });

      assertOk(data, 'Fetch pg response code list failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch pg response code list failed');
    }
  }

  @Action({ rawError: true })
  async UpdatePGCResponseCode(params: IFaqResponseCodeUpdate) {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: PGC_URL + FAQ_RESPONSE_CODE_UPDATE,
        method: M_POST,
        data: {
          list: params,
          id: user._id,
          username: user.username,
          source: user.source,
          parentId: user.parent
        }
      });

      assertOk(data, 'Update response code failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Update response code failed');
    }
  }

  // AmbSuperGames
  @Action({ rawError: true })
  async FetchAmbSuperGamesFaqList() {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: `${AMB_SUPER_GAMES_URL}${FAQ_LIST}?role=${user.role}`,
        method: M_GET
      });

      assertOk(data, 'Fetch pg faq list failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch pg faq list failed');
    }
  }

  @Action({ rawError: true })
  async UpdateAmbSuperGamesFaq(params: IFaqUpdate[]) {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: AMB_SUPER_GAMES_URL + FAQ_UPDATE,
        method: M_POST,
        data: {
          list: params,
          id: user._id,
          username: user.username,
          source: user.source,
          parentId: user.parent
        }
      });

      assertOk(data, 'Update faq failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Update faq failed');
    }
  }

  @Action({ rawError: true })
  async FetchAmbSuperGamesResponseCodeList() {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: `${AMB_SUPER_GAMES_URL}${FAQ_RESPONSE_CODE}?role=${user.role}`,
        method: M_GET
      });

      assertOk(data, 'Fetch pg response code list failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch pg response code list failed');
    }
  }

  @Action({ rawError: true })
  async UpdateAmbSuperGamesResponseCode(params: IFaqResponseCodeUpdate) {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: AMB_SUPER_GAMES_URL + FAQ_RESPONSE_CODE_UPDATE,
        method: M_POST,
        data: {
          list: params,
          id: user._id,
          username: user.username,
          source: user.source,
          parentId: user.parent
        }
      });

      assertOk(data, 'Update response code failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Update response code failed');
    }
  }

  // Ambpoker
  @Action({ rawError: true })
  async FetchAmbPokerFaqList() {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: `${AMB_POKER_URL}${FAQ_LIST}?role=${user.role}`,
        method: M_GET
      });

      assertOk(data, 'Fetch pg faq list failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch pg faq list failed');
    }
  }

  @Action({ rawError: true })
  async UpdateAmbPokerFaq(params: IFaqUpdate[]) {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: AMB_POKER_URL + FAQ_UPDATE,
        method: M_POST,
        data: {
          list: params,
          id: user._id,
          username: user.username,
          source: user.source,
          parentId: user.parent
        }
      });

      assertOk(data, 'Update faq failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Update faq failed');
    }
  }

  @Action({ rawError: true })
  async FetchAmbPokerResponseCodeList() {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: `${AMB_POKER_URL}${FAQ_RESPONSE_CODE}?role=${user.role}`,
        method: M_GET
      });

      assertOk(data, 'Fetch pg response code list failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch pg response code list failed');
    }
  }

  @Action({ rawError: true })
  async UpdateAmbPokerResponseCode(params: IFaqResponseCodeUpdate) {
    try {
      const user = serviceUtils.getUserPersistent().user ?? {};
      const { data } = await axios({
        url: AMB_POKER_URL + FAQ_RESPONSE_CODE_UPDATE,
        method: M_POST,
        data: {
          list: params,
          id: user._id,
          username: user.username,
          source: user.source,
          parentId: user.parent
        }
      });

      assertOk(data, 'Update response code failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Update response code failed');
    }
  }
}
